import { crudActions } from "@/services/CrudActions";
import { crudMdActions } from "@/services/CrudMdActions";

export default {
  ...crudActions("proyectos"),
  ...crudMdActions("proyectos"),
};
